import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e4087d5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lp-resource__main" }
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 1,
  class: "lp-resource__title"
}
const _hoisted_4 = { class: "lp-resource__meta lp-resource__meta--inline" }
const _hoisted_5 = { class: "lp-resource__meta lp-resource__meta--column" }
const _hoisted_6 = { class: "lp-resource__status" }
const _hoisted_7 = {
  key: 0,
  class: "lp-resource__done"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "lp-resource__ring",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-lock-fill" }, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "lp-resource__plans"
}

import { computed, ref } from 'vue';
import {
    IResources,
    PLANS_URL,
    RESOURCE_ICONS,
    hasAccess,
    resourceHref,
    resourceKind,
    resourceLevel,
    resourceTitle,
    useLearningPathI18n,
} from './learningPath';


export default /*#__PURE__*/_defineComponent({
  props: {
    resource: null,
    pathwayId: null,
    current: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    resource: IResources
    pathwayId: string
    current: boolean
}



const { tl } = useLearningPathI18n();

const status = computed<'lock' | 'completed' | 'incomplete'>(() => {
    if (!hasAccess(props.resource)) return 'lock';
    return props.resource.completed ? 'completed' : 'incomplete';
});

const kind = computed(() => resourceKind(props.resource));
const title = computed(() => resourceTitle(props.resource));
const href = computed(() => resourceHref(props.pathwayId, props.resource));

const meta = computed(() => {
    const level = resourceLevel(props.resource);
    const type = tl(`type_${kind.value}`);
    return level ? `${type} • ${tl(`level_${level}`)}` : type;
});

const actionLabel = computed(() => {
    if (props.current) return tl('continue');
    return kind.value === 'lesson' ? tl('watch') : tl('access_resource');
});

const showPlans = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["lp-resource", [`lp-resource--${_unref(status)}`, { 'lp-resource--current': __props.current }]])
  }, [
    _createElementVNode("i", {
      class: _normalizeClass(["lp-resource__icon", _unref(RESOURCE_ICONS)[_unref(kind)]])
    }, null, 2),
    _createElementVNode("div", _hoisted_1, [
      (_unref(href) && _unref(status) !== 'lock')
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: _unref(href),
            target: "_blank",
            class: "lp-resource__title"
          }, _toDisplayString(_unref(title)), 9, _hoisted_2))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(title)), 1)),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(meta)), 1)
    ]),
    _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(meta)), 1),
    _createElementVNode("div", _hoisted_6, [
      (_unref(status) === 'completed')
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_unref(tl)('completed')), 1)
          ]))
        : (_unref(status) === 'incomplete')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_9,
              (_unref(href))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: _unref(href),
                    target: "_blank",
                    class: _normalizeClass(["lp-btn lp-btn--sm", { 'lp-btn--outline': !__props.current }])
                  }, _toDisplayString(_unref(actionLabel)), 11, _hoisted_10))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "lp-resource__unlock",
              onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (showPlans.value = true)),
              onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (showPlans.value = false)),
              onFocusin: _cache[2] || (_cache[2] = ($event: any) => (showPlans.value = true)),
              onFocusout: _cache[3] || (_cache[3] = ($event: any) => (showPlans.value = false))
            }, [
              _createElementVNode("a", {
                href: _unref(PLANS_URL),
                target: "_blank",
                class: "lp-btn lp-btn--sm lp-btn--muted"
              }, [
                _hoisted_12,
                _createTextVNode(" " + _toDisplayString(_unref(tl)('unlock')), 1)
              ], 8, _hoisted_11),
              (showPlans.value && __props.resource.plans_for_access?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("span", null, _toDisplayString(_unref(tl)('unlock_with')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.resource.plans_for_access, (plan) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: plan.id,
                        class: "lp-resource__plan"
                      }, _toDisplayString(plan.name), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 32))
    ])
  ], 2))
}
}

})